import { render, staticRenderFns } from "./traceabilityUpload.vue?vue&type=template&id=77ef046e&"
import script from "./traceabilityUpload.vue?vue&type=script&lang=js&"
export * from "./traceabilityUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports